import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedStageSelector($companyId: ID!, $eventId: ID!, $id: ID) {
    events(companyId: $companyId, filters: { idEq: $eventId }, first: 1) {
      nodes {
        id
        eventStages(filters: { idEq: $id }, first: 1) {
          nodes {
            id
            name
          }
        }
      }
    }
  }
`

export const Query = gql`
  query StageSelector(
    $companyId: ID!,
    $eventId: ID!,
    $filters: EventStageFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    events(companyId: $companyId, filters: { idEq: $eventId }, first: 1) {
      nodes {
        id
        eventStages(filters: $filters, after: $after, before: $before, first: $first, last: $last) {
          nodes {
            id
            name
          }
          pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
        }
      }
    }
  }
`
